<!-- eslint-disable vue/no-mutating-props -->
<template>
  <el-dialog
    v-model="show"
    :title="PageNum"
    width="600"
    :fullscreen="$vuetify.display.width <= 400 ? true : false"
    class="public-style"
    destroy-on-close
    align-center
    @close="close"
  >
    <el-row :gutter="20" class="container ma-0 y-center">
      <transition :name="transitionName" mode="out-in">
        <template class="d-block">
          <!-- <p :key="PageNum" class="me-primary-light">Page {{ PageNum }}</p> -->
          <p class="text-white">{{ currentQuestion.question }}</p>
          <el-text v-if="currentQuestion.code === 2" type="warning" tag="i">
            {{
              charger_modal != null
                ? "Charger Session Count:"
                : "Port Session Count:"
            }}
            <strong>{{ sessions_count }}</strong>
          </el-text>
          <div v-if="currentQuestion.type === 'radio'">
            <el-radio-group
              size="large"
              class="border-0"
              v-if="currentQuestion.code === 2"
              v-model="radioAnswer"
            >
              <el-radio
                :disabled="sessions_count == 0"
                size="large"
                :label="'yes'"
              >
                Yes
              </el-radio>
              <el-radio
                :disabled="sessions_count > 0"
                class="font-warning"
                size="large"
                :label="'no'"
              >
                No
              </el-radio>
            </el-radio-group>
            <el-radio-group
              size="large"
              class="border-0"
              v-else-if="currentQuestion.code === 4 || currentQuestion.code === 9"
              v-model="radioAnswer"
            >
              <el-radio
                :disabled="radioAnswer == 'no'"
                size="large"
                :label="'yes'"
              >
                Yes
              </el-radio>
              <el-radio
                :disabled="radioAnswer == 'yes'"
                class="font-warning"
                size="large"
                :label="'no'"
              >
                No
              </el-radio>
            </el-radio-group>



            <el-radio-group
              size="large"
              class="border-0"
              v-else
              v-model="radioAnswer"
            >
              <el-radio size="large" :label="'yes'">Yes</el-radio>
              <el-radio class="font-warning" size="large" :label="'no'">
                No
              </el-radio>
            </el-radio-group>
          </div>
          <div v-else-if="currentQuestion.type === 'info'">
            <el-text type="warning" tag="i">
              Current Monitoring Period:
              <strong>{{ monitoring_current.split("T")[0] }}</strong>
            </el-text>
            <p class="text-green py-2">
              <el-text class="text-white" tag="i"> Answer: </el-text>
              <strong>{{ beforeMonitoringStatus }}</strong>
            </p>
          </div>
          <div v-else-if="currentQuestion.type === 'list' && currentQuestion.code === 8" >
            <p class="text-white">Monitoring Periods:</p>
            <el-checkbox-group v-model="select_monitoring_periods">
              <el-checkbox 
                v-for="item in monitoringPeriods" 
                :key="item.id" 
                :label="{id: item.id, name: item.name, start_date: item.start_date.replace('T', ' '), end_date: item.end_date.replace('T', ' ')}" 
                :value="item.id">
                <el-tooltip placement="top" effect="light">
                  <template #content>
                      <span class="moderat-meGreen-bold-12">Start Date:</span> {{item.start_date.replace("T", " ")}} <br/>
                      <span class="moderat-meGreen-bold-12">End Date:</span> {{item.end_date.replace("T", " ")}}
                  </template>
                  <span>{{ item.name }}</span>
                </el-tooltip>
              </el-checkbox>
            </el-checkbox-group>
          </div>
          <el-row class="m-0" v-if="currentQuestion.code === 4">
            <el-col :span="24">
              <p class="font-18-b text-white">Validation Field Changes :</p>
            </el-col>
            <template v-if="site_data != null">
              <div class="flex">
                <el-tag
                  effect="dark"
                  :type="
                    site_data.country != primary_data.country
                      ? 'success'
                      : 'danger'
                  "
                  class="m-1"
                >
                  Country
                </el-tag>
                <el-tag
                  effect="dark"
                  :type="
                    site_data.state != primary_data.state ? 'success' : 'danger'
                  "
                  class="m-1"
                >
                  State
                </el-tag>
                <el-tag
                  effect="dark"
                  :type="
                    site_data.postcode != primary_data.postcode
                      ? 'success'
                      : 'danger'
                  "
                  class="m-1"
                >
                  Postcode
                </el-tag>
              </div>
            </template>
            <template v-else-if="charger_data != null">
              <div class="flex">
                <el-tag
                  effect="dark"
                  :type="
                    charger_data.charger_type != primary_data.charger_type
                      ? 'success'
                      : 'danger'
                  "
                  class="m-1"
                >
                  Charger Type
                </el-tag>
                <el-tag
                  effect="dark"
                  :type="
                    charger_data.operational_date !=
                    primary_data.operational_date
                      ? 'success'
                      : 'danger'
                  "
                  class="m-1"
                >
                  Operational Date
                </el-tag>
                <el-tag
                  effect="dark"
                  :type="
                    charger_data.decommissioning_date !=
                    primary_data.decommissioning_date
                      ? 'success'
                      : 'danger'
                  "
                  class="m-1"
                >
                  Decommissioning Date
                </el-tag>
                <el-tag
                  effect="dark"
                  :type="
                    charger_data.charger_capacity_kW !=
                    primary_data.charger_capacity_kW
                      ? 'success'
                      : 'danger'
                  "
                  class="m-1"
                >
                  Capacity kW
                </el-tag>
              </div>
            </template>
            <template v-if="port_data != null">
              <div class="flex">
                <el-tag
                  effect="dark"
                  :type="
                    port_data.port_capacity_kw != primary_data.port_capacity_kw
                      ? 'success'
                      : 'danger'
                  "
                  class="m-1"
                >
                  Port Capacity kW
                </el-tag>
              </div>
            </template>
          </el-row>
          <el-row v-if="currentQuestion.code === 9 && charger_data != null">
            <el-col :span="24">
              <p class="text-white">Decommissioning Date Changes :</p>
              <p :class="unable_to_next ? 'text-red' : 'text-green'">
                <el-text class="text-white" tag="i"> Current Monitoring Period: </el-text>
                <strong> {{ monitoring_current.split("T")[0] }} --- {{ monitoring_current_end_date.split("T")[0] }}</strong> <br>
                <el-text class="text-white" tag="i"> New Decommissioning Date: </el-text>
                <strong> {{ charger_data.decommissioning_date ? charger_data.decommissioning_date.split("T")[0] : "N/A" }} </strong>
              </p>
              <p class="text-green">
                <el-text class="text-white" tag="i"> Changed Fields: </el-text>
              </p>
              <div class="flex">
                  <el-tag
                    effect="dark"
                    :type="
                      charger_data.charger_type != primary_data.charger_type
                        ? 'success'
                        : 'danger'
                    "
                    class="m-1"
                  >
                    Charger Type
                  </el-tag>
                  <el-tag
                    effect="dark"
                    :type="
                      charger_data.operational_date !=
                      primary_data.operational_date
                        ? 'success'
                        : 'danger'
                    "
                    class="m-1"
                  >
                    Operational Date
                  </el-tag>
                  <el-tag
                    effect="dark"
                    :type="
                      charger_data.decommissioning_date !=
                      primary_data.decommissioning_date
                        ? 'success'
                        : 'danger'
                    "
                    class="m-1"
                  >
                    Decommissioning Date
                  </el-tag>
                  <el-tag
                    effect="dark"
                    :type="
                      charger_data.charger_capacity_kW !=
                      primary_data.charger_capacity_kW
                        ? 'success'
                        : 'danger'
                    "
                    class="m-1"
                  >
                    Capacity kW
                  </el-tag>
              </div>
              <p class="text-white py-2" v-if="unable_to_next">
                <el-text class="text-red font-18-b" tag="i"> Unable to update charger: </el-text>
                <strong> No changes to any of (charger type, operational date, decommissioning date, capacity kW), or</strong> <br/>
                <strong> New decommissioning date is not within the current monitoring period </strong>
              </p>
            </el-col>
          </el-row>
        </template>
      </transition>
    </el-row>

    <!-- buttons section -->
    <template #footer>
      <el-row :gutter="20" class="ma-0">
        <el-col :span="12" class="x-start y-center">
          <el-button
            color="#0d3937"
            size="medium"
            class="me-primary-light"
            @click.stop="handlePerv"
          >
            <i class="fa fa-arrow-left me-2"></i> <span class="pl-1">Prev</span>
          </el-button>
        </el-col>
        <el-col :span="12" class="x-end y-center">
          <el-button
            color="#0d3937"
            size="medium"
            class="me-primary-light"
            @click.stop="close"
          >
            <span class="pr-1">Cancel</span>
            <i class="fa fa-times ml-2"></i>
          </el-button>
          <el-button
            v-if="!unable_to_next"
            color="#0d3937"
            size="medium"
            class="me-primary-light"
            @click.stop="handleNext"
          >
            <span class="pr-1">{{no_more_ques ? "Submit" : "Next"}}</span>
            <i class="fa fa-arrow-right ml-2"></i>
          </el-button>

          <el-button
            v-if="able_to_submit && unable_to_next"
            color="#0d3937"
            size="medium"
            class="me-primary-light"
            @click.stop="submit_ques"
          >
            <span class="pr-1">Submit</span>
            <i class="fa fa-arrow-right ml-2"></i>
          </el-button>
        </el-col>
      </el-row>
    </template>
  </el-dialog>
</template>

<script>
// import "animate.css";
import UserService from "../../services/user.service";
import moment from "moment";

export default {
  props: {
    open_modal: {
      type: Boolean,
      default: false,
    },
    port_modal: {
      type: Object,
      default: null,
    },
    charger_modal: {
      type: Object,
      default: null,
    },
    site_modal: {
      type: Object,
      default: null,
    },
    primary_modal: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      show: this.open_modal,
      PageNum: 1,
      direction: "next",
      port_data: null,
      charger_data: null,
      site_data: null,
      primary_data: null,
      questions: [
        {
          code: 1,
          question:
            "Was the charger added within the current monitoring period and was not part of the project before?",
          type: "info",
          enterTo: "",
          beforeCode: 0,
        },
        {
          code: 2,
          question: "Does the site/charger/port have sessions?",
          type: "radio",
          enterTo: "yes",
          beforeCode: 1,
        },
        {
          code: 3,
          question: "Is this a data entry error?",
          type: "radio",
          enterTo: "no",
          beforeCode: 1,
        },
        {
          code: 4,
          question:
            "Is this a change that affects the validation checks and abatement numbers and needs creating a new instance, and not only the decommissioning date is changed?",
          type: "radio",
          enterTo: "yes",
          beforeCode: 2,
        },
        {
          code: 5,
          question:
            "Are the sessions just in issued/issuance requested monitoring periods?",
          type: "radio",
          enterTo: "yes",
          beforeCode: 4,
        },
        {
          code: 9,
          question:
            "Is the changed decommissioning date within the current monitoring period?",
          type: "radio",
          enterTo: "no",
          beforeCode: 4,
        },
        {
          code: 6,
          question: "Is this a data entry error?",
          type: "radio",
          enterTo: "no",
          beforeCode: 5,
        },
        {
          code: 7,
          question:
            "Is this a charger upgrade? Is this a transfer of charger between clients?",
          type: "radio",
          enterTo: "no",
          beforeCode: 6,
        },
        {
          code: 8,
          question:
            "Which monitoring periods should this affect? (a list of check boxes with the name of all MPs) ",
          type: "list",
          enterTo: "yes",
          beforeCode: 6,
        },
      ],
      stepResult: [],
      currentQuestionCode: 1,
      currentAnswer: "no",
      radioAnswer: "no",
      sessions_count: 0,
      monitoring_current: "",
      monitoring_current_end_date: "",
      operational_date: "",

      // charger validation field check
      charger_validation_field_check: {
        charger_type: 0,
        operational_date: 0,
        decommissioning_date: 0,
        charger_capacity_kW: 0,
      },

      unable_to_next: false,
      able_to_submit: false,

      // Monitoring Periods DATA
      monitoringPeriods: [],

      // data for Monitoring Periods filter button
      selectedMonitorPeriod: {
          id: null,
          name: null,
          dateTimeRange: [null, null],
      },

      // selected monitoring periods (list of {id, name, start_date, end_date})
      select_monitoring_periods: [],
    };
  },
  computed: {
    // check if only the decommissioning date is changed; only when result is 4, means only decommissioning date is changed
    is_only_decommissioning_date_changed() {
      let result =  this.charger_validation_field_check.charger_type + this.charger_validation_field_check.operational_date + this.charger_validation_field_check.decommissioning_date + this.charger_validation_field_check.charger_capacity_kW;
      if (result === 4) return true;
      return false;
    },

    is_any_field_changed() {
      let result =  this.charger_validation_field_check.charger_type + this.charger_validation_field_check.operational_date + this.charger_validation_field_check.decommissioning_date + this.charger_validation_field_check.charger_capacity_kW;
      if (result !== 0) return true;
      return false;
    },

    no_more_ques() {
      const nextQ = this.questions.find(
        (q) =>
          q.beforeCode === this.currentQuestionCode &&
          q.enterTo === this.currentAnswer
      );
      if (nextQ == null) return true;
      return false;
    },

    transitionName() {
      return this.direction === "next" ? "slide-next" : "slide-prev";
    },
    // currentQuestion() {
    //   var ques =
    //     this.questions.find((q) => q.code === this.currentQuestionCode) || {};
    //   if (this.currentQuestionCode == 2 && this.sessions_count > 0) {
    //     // eslint-disable-next-line vue/no-side-effects-in-computed-properties
    //     this.radioAnswer = "yes";
    //   }
    //   if (
    //     this.currentQuestionCode == 4 &&
    //     this.site_data != null &&
    //     (this.site_data.country != this.primary_data.country ||
    //       this.site_data.state != this.primary_data.state ||
    //       this.site_data.postcode != this.primary_data.postcode)
    //   ) {
    //     // eslint-disable-next-line vue/no-side-effects-in-computed-properties
    //     this.radioAnswer = "yes";
    //   }
    //   if (
    //     this.currentQuestionCode == 4 &&
    //     this.charger_data != null &&
    //     this.is_any_field_changed &&
    //     !this.is_only_decommissioning_date_changed
    //   ) {
    //     // eslint-disable-next-line vue/no-side-effects-in-computed-properties
    //     this.radioAnswer = "yes";
    //   }
    //   if (
    //     this.currentQuestionCode == 4 &&
    //     this.charger_data != null &&
    //     this.is_any_field_changed &&
    //     this.is_only_decommissioning_date_changed)
    //   {
    //     // eslint-disable-next-line vue/no-side-effects-in-computed-properties
    //     this.radioAnswer = "no";
    //   }
    //   if (
    //     this.currentQuestionCode == 4 &&
    //     this.port_data != null &&
    //     this.port_data.port_capacity_kw != this.primary_data.port_capacity_kw
    //   ) {
    //     // eslint-disable-next-line vue/no-side-effects-in-computed-properties
    //     this.radioAnswer = "yes";
    //   }
    //   if (
    //     // only decommissioning date changed, and it is within the current monitoring period
    //     // update charger with question TTFT
    //     this.currentQuestionCode == 9 &&
    //     this.is_only_decommissioning_date_changed &&
    //     this.is_any_field_changed &&
    //     this.charger_data.decommissioning_date >= this.monitoring_current &&
    //     this.charger_data.decommissioning_date <= this.monitoring_current_end_date
    //   ) {
    //     // eslint-disable-next-line vue/no-side-effects-in-computed-properties
    //     this.radioAnswer = "yes";
    //   }
    //   if (this.currentQuestionCode == 9 && 
    //       this.radioAnswer == "no"
    //   ) {
    //     // eslint-disable-next-line vue/no-side-effects-in-computed-properties
    //     this.unable_to_next = true;
    //   }
      
    //   // console.log("question", ques);
      
    //   return ques;
    // },
    currentQuestion() {
      return this.func_currentQuestion();
    },
    beforeMonitoringStatus() {
      let condition =
        moment(this.monitoring_current) >= moment(this.operational_date);
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.currentAnswer = condition ? "yes" : "no";
      // alert(this.monitoring_current);
      return condition ? "Yes, it was before" : "No, it wasn't before";
    },
  },
  watch: {
    // check if only the decommissioning date is changed;
    "charger_data.charger_type": {
      handler(newVal) {
        if (newVal === this.primary_data.charger_type) {
          this.charger_validation_field_check.charger_type = 0;
        } else {
          this.charger_validation_field_check.charger_type = -1;
        }
      },
      deep: true,
    },
    "charger_data.operational_date": {
      handler(newVal) {
        if (newVal === this.primary_data.operational_date) {
          this.charger_validation_field_check.operational_date = 0;
        } else {
          this.charger_validation_field_check.operational_date = -1;
        }
      },
      deep: true,
    },
    "charger_data.decommissioning_date": {
      handler(newVal) {
        if (newVal === this.primary_data.decommissioning_date) {
          this.charger_validation_field_check.decommissioning_date = 0;
        } else {
          this.charger_validation_field_check.decommissioning_date = 4;
        }
      },
      deep: true,
    },
    "charger_data.charger_capacity_kW": {
      handler(newVal) {
        if (newVal === this.primary_data.charger_capacity_kW) {
          this.charger_validation_field_check.charger_capacity_kW = 0;
        } else {
          this.charger_validation_field_check.charger_capacity_kW = -1;
        }
      },
      deep: true,
    },
    // check if only the decommissioning date is changed;

    // eslint-disable-next-line no-unused-vars
    open_modal: function (newVal, oldVal) {
      this.show = newVal;
      this.stepResult = [];
      this.PageNum = 1;
      this.currentQuestionCode = 1;
      this.currentAnswer = "no";
      this.radioAnswer = "no";
      this.sessions_count = 0;
      this.monitoring_current = "";
      this.monitoring_current_end_date = "";
      this.operational_date = "";
      this.select_monitoring_periods = [];
      if (newVal == true) {
        this.primary_data = JSON.parse(this.primary_modal);

        // console.log(this.port_modal);
        if (this.port_modal !== null) {
          this.port_data = this.port_modal;
          this.sessions_count = this.port_data.sessions_count;
          this.monitoring_current = this.port_data.monitoring_current;
          this.operational_date = this.port_data.operational_date;
        }

        if (this.charger_modal !== null) {
          console.log("charger_modal", this.charger_modal);
          
          this.charger_data = this.charger_modal;
          this.sessions_count = this.charger_data.sessions_count;
          this.monitoring_current = this.charger_data.monitoring_current;
          this.monitoring_current_end_date = this.charger_data.monitoring_current_end_date;
          this.operational_date = this.charger_data.operational_date;
          this.primary_data.operational_date =
            this.primary_data.operational_date == null
              ? null
              : moment(this.primary_data.operational_date).format("YYYY-MM-DD");
          this.primary_data.decommissioning_date =
            this.primary_data.decommissioning_date == null
              ? null
              : moment(this.primary_data.decommissioning_date).format(
                  "YYYY-MM-DD"
                );
        }

        if (this.site_modal !== null) {
          // console.log(this.site_modal);
          this.site_data = this.site_modal;
          this.sessions_count = this.site_data.sessions_count;
          this.monitoring_current = this.site_data.monitoring_current;
          const minDate = this.site_data.chargers
            .map((charger) => moment(charger.operational_date))
            .reduce((min, date) => (date.isBefore(min) ? date : min), moment());
          this.operational_date = minDate.toISOString();
        }
      }
    },
    radioAnswer: function (newVal) {
      this.currentAnswer = newVal;
    },

  },

  async mounted() {
    await this.fetchMonitoringPeriods();
  },

  methods: {
    func_currentQuestion() {
      var ques =
        this.questions.find((q) => q.code === this.currentQuestionCode) || {};

      switch (this.currentQuestionCode) {

        // code 2: does the site/charger/port have sessions?
        case 2:
          if (this.sessions_count > 0) {
            this.radioAnswer = "yes";
          } else {
            this.radioAnswer = "no";
          }
          break;

        // code 4: is this a change that affects the validation checks and abatement numbers and needs creating a new instance, 
        // and not only the decommissioning date is changed?
        case 4:
          // for site
          if (this.site_data != null) {
            if (
                this.site_data.country != this.primary_data.country ||
                this.site_data.state != this.primary_data.state ||
                this.site_data.postcode != this.primary_data.postcode
              ) 
              {
                 this.radioAnswer = "yes";
              } else {
                // no field changed
                this.stepResult.push({
                  questionCode: 4,
                  questionText: "Is this a change that affects the validation checks and abatement numbers and needs creating a new instance, and not only the decommissioning date is changed?",
                  answer: "no",
                  type: "radio",
                });
                this.unable_to_next = true;
                this.able_to_submit = true;
              }

          // for port
          } else if (this.port_data != null) {
            if (
              this.port_data.port_capacity_kw != this.primary_data.port_capacity_kw
            ) {
              this.radioAnswer = "yes";
            } else {
              // no field changed
              this.stepResult.push({
                questionCode: 4,
                questionText: "Is this a change that affects the validation checks and abatement numbers and needs creating a new instance, and not only the decommissioning date is changed?",
                answer: "no",
                type: "radio",
              });
              this.unable_to_next = true;
              this.able_to_submit = true;
            }

          // for charger
          } else if (this.charger_data != null) {
            if (this.is_any_field_changed) {
              if (this.is_only_decommissioning_date_changed) {
                // field changed, and is only decommissioning date changed
                this.radioAnswer = "no";
              } else {
                // field changed, but not only decommissioning date changed
                this.radioAnswer = "yes";
              }
            } else {
              // no field changed
              this.stepResult.push({
                questionCode: 4,
                questionText: "Is this a change that affects the validation checks and abatement numbers and needs creating a new instance, and not only the decommissioning date is changed?",
                answer: "no",
                type: "radio",
              });
              this.unable_to_next = true;
              this.able_to_submit = true;
            }
          } else {
            // no site, charger, or port data
            console.log("out of conditions: no site, charger, or port data");
            return;
          }
          break;
        // code 8 : Which monitoring periods should this affect? (a list of check boxes with the name of all MPs)
        case 8:
          if (this.select_monitoring_periods.length > 0) {
            let item = this.stepResult.find(item => item.questionCode === 8);
            if (item) {
              item.answer = "yes";
              item.affected_monitoring_periods = this.select_monitoring_periods;
            } else {
              this.stepResult.push({
                questionCode: 8,
                questionText: "Which monitoring periods should this affect? (a list of check boxes with the name of all MPs) ",
                answer: "yes",
                affected_monitoring_periods: this.select_monitoring_periods,
                type: "list",
              });
            }
            this.unable_to_next = true;
            this.able_to_submit = true;
          } else {
            let item = this.stepResult.find(item => item.questionCode === 8);
            if (item) {
              item.answer = "no";
              item.affected_monitoring_periods = [];
            } else {
              this.stepResult.push({
                questionCode: 8,
                questionText: "Which monitoring periods should this affect? (a list of check boxes with the name of all MPs) ",
                answer: "no",
                affected_monitoring_periods: [],
                type: "list",
              });
            }
            this.unable_to_next = true;
            this.able_to_submit = false;
          }
          break;

        // code 9: is the changed decommissioning date within the current monitoring period?
        case 9:
          if (this.port_data != null) {
            this.unable_to_next = true;
          }
          else if (this.site_data != null) {
            this.unable_to_next = true;
          }
          else if (
            // only for charger
            this.charger_data != null
         ) {
            if (
              this.is_only_decommissioning_date_changed &&
              this.is_any_field_changed && 
              this.charger_data.decommissioning_date >= this.monitoring_current &&
              this.charger_data.decommissioning_date <= this.monitoring_current_end_date
            ) {
              this.radioAnswer = "yes";
            } else {
              this.unable_to_next = true;
            }
          }
          break;
      
        default:
            break;
      }

      return ques;
    },


    close() {
      this.show = false;
      this.unable_to_next = false;
      this.able_to_submit = false;
      this.$emit("close_modal", false);
    },
    submit_ques() {
      console.log("submit_ques", this.stepResult);
      this.$emit("question_priority", this.stepResult);
    },
    modify_close_modal() {
      this.show_modify_modal = false;
    },
    handleNext() {
      this.direction = "next";
      // this.PageNum++;
      this.nextQuestion();
      console.log(this.PageNum);
      console.log(this.stepResult);
      // console.log(this.site_data);
      // console.log(this.primary_modal);
    },
    handlePerv() {
      if (this.PageNum != 1) {
        this.direction = "perv";
        // this.PageNum--;
        this.unable_to_next = false;
        this.able_to_submit = false;
        this.prevQuestion();
        console.log(this.PageNum);
        console.log(this.stepResult);
      }
    },
    setAnswer(answer) {
      this.currentAnswer = answer;
    },
    nextQuestion() {
      if (
        !this.stepResult.some(
          (res) => res.questionCode === this.currentQuestionCode
        )
      ) {
        this.stepResult.push({
          questionCode: this.currentQuestionCode,
          questionText: this.currentQuestion.question,
          answer: this.currentAnswer,
          type: this.currentQuestion.type,
        });
      } else {
        if (this.PageNum - 1 >= 0) {
          let index = this.PageNum - 1;
          this.stepResult[index].questionCode = this.currentQuestionCode;
          this.stepResult[index].questionText = this.currentQuestion.question;
          if (this.stepResult[index].answer != this.currentAnswer) {
            this.stepResult = this.stepResult
              .slice(0, this.PageNum)
              .map((item) => ({ ...item }));
          }
          this.stepResult[index].answer = this.currentAnswer;
        }
      }
      const nextQ = this.questions.find(
        (q) =>
          q.beforeCode === this.currentQuestionCode &&
          q.enterTo === this.currentAnswer
      );

      if (nextQ) {
        this.currentQuestionCode = nextQ.code;
        this.currentAnswer = "no";
        this.PageNum++;
        this.radioAnswer = "no";
      } else {
        // alert("No more questions!");
        this.$emit("question_priority", this.stepResult);
      }
    },
    prevQuestion() {
      this.PageNum--;

      this.select_monitoring_periods = [];

      if (this.PageNum - 1 >= 0) {
        let index = this.PageNum - 1;
        this.currentQuestionCode = this.stepResult[index].questionCode;
        this.currentAnswer = this.stepResult[index].answer;
        if (this.stepResult[index].type === "radio")
          this.radioAnswer = this.stepResult[index].answer;
      } else {
        alert("No more questions!");
      }
    },

    // Monitoring periods related functions
    async fetchMonitoringPeriods() {

            const handleMPSelection = async (monitoringPeriods) => {
              console.log("handleMPSelection", monitoringPeriods);
              let availableMPs = monitoringPeriods.filter(mp => mp.status != "under_audit" && mp.status != "issue_requested" && mp.status != "issued");
              if (availableMPs.length > 0) {
              this.monitoringPeriods = availableMPs; }
              else {
                this.monitoringPeriods = [];
                this.unable_to_next = true;
                this.able_to_submit = false;
                console.log("No available monitoring periods");
                return;
              }
            };

            // Start: Try from sessionStorage first
            const cached = sessionStorage.getItem("monitoringPeriods");
            if (cached) {
                try {
                const parsed = JSON.parse(cached);
                await handleMPSelection(parsed);
                return;
                } catch (err) {
                console.error("Error parsing sessionStorage monitoringPeriods");
                console.log("no monitoring periods in session data, fetching monitoring periods...");
                }
            }

            // Fetch from API if no session data
            try {
                const response = await UserService.getMonitoringPeriods(null, "", 1, 50, true);
                const data = response.data.monitoring_periods || [];

                if (data.length > 0) {
                sessionStorage.setItem("monitoringPeriods", JSON.stringify(data));
                await handleMPSelection(data);
                } else {
                // no data in MP database, set selected mp name to '12 months'
                console.log('Monitoring periods data is empty');
                return;
                }
            } catch (error) {
                this.loading = false;
                console.error("Monitoring periods fetch error:", error.message);
                if (error.response?.status === 401) {
                this.$router.push({ path: "/" });
                }
            } finally {
                this.loading = false;
            }
        },
  },
};
</script>

<style>
.el-dialog__title {
  color: white !important;
}
.el-dialog__body {
  padding: 30px 10px;
}
.el-input__inner {
  padding: 0 10px !important;
}

::-webkit-scrollbar {
  width: 8px;
}
/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.el-form-item__label {

  margin-bottom: 0 !important;
}
.el-form-item__content > .el-checkbox {
  margin-top: 16px;
  margin-bottom: 0;
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.dtp-customer > .el-input__wrapper {
  padding: 0 10px !important;
  height: 32px !important;
}

/* Transition */
.slide-enter-active {
  animation: slide-in 0.5s forwards;
}

.slide-leave-active {
  animation: slide-out 0.5s forwards;
}

@keyframes slide-in {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slide-out {
  from {
    transform: translateX(0);
    opacity: 1;
  }
  to {
    transform: translateX(-100%);
    opacity: 0;
  }
}

.slide-next-enter-active {
  animation: slide-in-right 0.08s forwards;
}
.slide-next-leave-active {
  animation: fade-out 0.08s forwards;
}

.slide-prev-enter-active {
  animation: slide-in-left 0.08s forwards;
}
.slide-prev-leave-active {
  animation: fade-out 0.08s forwards;
}

@keyframes slide-in-right {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slide-in-left {
  from {
    transform: translateX(-100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes fade-out {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
</style>
